import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL || "https://api.darwinx.com.br";

const httpClient = axios.create({ baseURL });

export default httpClient;
